import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { validate } from "./validations.jsx";
import { Input } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { accountExistByEmail } from "../../../../../app/redux/slices/app/legacySlice";
import {
  getSalesForceUserDetails,
  saveUserDetails,
} from "../../../../../app/redux/slices/app/registerSlice";
import CustomSnackbar from "../../../../components/customComponents/CustomSnackbar/index.js";
import { CircularProgress } from "@mui/material";
import { TextMaskCustom } from "../../../../../app/utils/utils";
import { validateForm } from "../../../../../features/components/customComponents/customValidation/index";

const AddCustomerByAdmin = () => {
  const [verifyPhoneAndemail, setVerifyPhoneAndemail] = useState(false);
  const [associatedAccounts, setAssociatedAccounts] = useState([]);
  const [selectedAssociatedAccounts, setSelectedAccounts] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const dispatch = useDispatch();
  const [errorMessages, setErrorMessages] = useState({});
  const getSalesForceData = useSelector(
    (state) => state?.registerSlice.getSalesForceData
  );
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const transformData = (formData, firresponse) => {
    return {
      first_name: formData.firstName,
      last_name: formData.lastName,
      email: formData.emailId,
      password: formData.password,
      businessName: formData.businessName,
      phone: formatPhoneNumber(formData.phone),
      accounts: firresponse.map((acc) => ({
        parent_account_no: acc.parent_account_id || "",
        billing_account_no:
          acc.gas_billing_accountid || acc.fiber_billing_accountid || "",
        service_account_no: acc.account_id || "",
        parent_account_id: acc.parent_account_id || "",
        billing_account_id:
          acc.gas_billing_accountid || acc.fiber_billing_accountid || "",
        service_account_id: acc.premises_id || "",
        account_number: acc.account_number || "",
        service_type_code: acc.service_type || "",
        service_address_line1: acc.address_line1 || "",
        service_address_line2: acc.address_line2 || "",
        service_address_city: acc.address_city || "",
        service_address_state: acc.address_state || "",
        service_address_postal_code: acc.address_postal_code || "",
        user_type:
        //  formData.isCustomer
        //   ? "Customer"
        //   : 
          formData.isBuilder
          ? "Builder"
          : formData.isHOA
          ? "HOA"
          : formData.isLandDeveloper
          ? "Land Developer"
          : "Unknown",
      })),
    };
  };

  const [formData, setFormData] = useState({
    // isCustomer: true,
    isBuilder: true,
    isHOA: false,
    isLandDeveloper: false,
    firstName: "",
    lastName: "",
    emailId: "",
    phone: "",
    password: "",
    confirmPassword: "",
  });
  const validationRules = {
    firstName: { required: true, name: "First Name" },
    lastName: { required: true, name: "Last Name" },
    emailId: {
      required: true,
      name: "Email",
      format: /^[^@]+@[^@]+\.[^@]+$/,
    },
    phone: {
      required: true,
      name: "Phone Number",
      minDigits: "10",
    },
  };

  const fetchSalesForceUserDetails = async () => {
    try {
      const emailResponse = await dispatch(
        getSalesForceUserDetails(formData?.emailId)
      );

      if (emailResponse?.payload?.data?.data?.acc_details?.length > 0) {
        setAssociatedAccounts((prev) => [
          ...prev,
          ...emailResponse.payload.data.data.acc_details,
        ]);
      } else if (emailResponse.error) {
        setSuccessMessage(`Error:No account found with the give email`);
        setOpenSnackbar(true);
      }

      const phoneResponse = await dispatch(
        getSalesForceUserDetails(formatPhoneNumber(formData?.phone))
      );

      if (phoneResponse?.payload?.data?.data?.acc_details.length > 0) {
        setAssociatedAccounts((prev) => [
          ...prev,
          ...phoneResponse.payload.data.data.acc_details,
        ]);
      } else if (phoneResponse.error) {
        setSuccessMessage(`Error:No user found`);
        setOpenSnackbar(true);
      }
    } catch (error) {
      setSuccessMessage(`Error:No user found`);
      setOpenSnackbar(true);
    }
  };

  const formatPhoneNumber = (phoneNumber) => {
    return phoneNumber.replace(/\D/g, "");
  };

  const onValidate = async () => {
    let curFormData = {
      ...formData,
      phone: formatPhoneNumber(formData?.phone),
    };
    let newError = validate(curFormData);
    let validationErrors = validateForm(formData, validationRules);
    const combinedErrors = { ...newError, ...validationErrors };
    setErrorMessages(combinedErrors);
    let noerror = Object.keys(combinedErrors).length === 0;
    if (noerror) {
      const eixstingAccountResponse = await dispatch(
        accountExistByEmail({
          email: formData.emailId,
        })
      );
      if (eixstingAccountResponse?.payload?.data?.data?.user_id) {
        setSuccessMessage("Error:Email address already exists");
        setOpenSnackbar(true);
        return;
      } else {
        setVerifyPhoneAndemail(true);
        scrollToTop();
        fetchSalesForceUserDetails();
      }
    }
    return noerror;
  };

  const handleCheckboxChange = (account) => {
    setSelectedAccounts((prev) => {
      const isSelected = prev.some(
        (item) => item.account_id === account.account_id
      );
      if (isSelected) {
        return prev.filter((item) => item.account_id !== account.account_id);
      } else {
        return [...prev, account];
      }
    });
  };
  const handleSelectandunselectAll = () => {
    if (selectedAssociatedAccounts.length === associatedAccounts.length) {
      setSelectedAccounts([]);
    } else {
      setSelectedAccounts(associatedAccounts);
    }
  };
  const resetSelection = () => {
    setSelectedAccounts([]);
  };

  const onClickSave = async () => {
    const newFormData = transformData(formData, selectedAssociatedAccounts);
    if (newFormData.accounts.length > 0) {
      const saveResponse = await dispatch(saveUserDetails(newFormData));
      if (saveResponse.error) {
        setSuccessMessage(`Error:Something went wrong. Please try later`);
        setOpenSnackbar(true);
      } else {
        setSuccessMessage(`User created successfully`);
        setOpenSnackbar(true);
        setTimeout(() => {
          setFormData({
            // isCustomer: true,
            isBuilder: true,
            isHOA: false,
            isLandDeveloper: false,
            firstName: "",
            lastName: "",
            emailId: "",
            phone: "",
            password: "",
            confirmPassword: "",
          });
          setVerifyPhoneAndemail(false);
          setAssociatedAccounts([]);
          setSelectedAccounts([]);
        }, [2000]);
      }
    }
  };
  const clearform=()=>{
    setFormData({
    // isCustomer: true,
    isBuilder: true,
    isHOA: false,
    isLandDeveloper: false,
    firstName: "",
    lastName: "",
    emailId: "",
    phone: "",
    password: "",
    confirmPassword: "",
  })
  }

  return (
    <>
      <CustomSnackbar
        openSnackbar={openSnackbar}
        severity={successMessage.includes("Error") ? "error" : "success"}
        message={successMessage}
        autoHideDuration={1500}
        handleClose={() => {
          setOpenSnackbar(false);
          setSuccessMessage("");
        }}
      />

      <div className="row min-h-100">
        <div className="col-xxl-12">
          {!verifyPhoneAndemail && (
            <>
              <div className="row">
                <div className="col-lg-12">
                  <div className="form-group">
                    <label className="searchform-inputlabel">
                      User type <span>*</span>
                    </label>
                    <div className="d-flex gap-3 align-items-center mt-2">
                      {/* <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="inlineRadioOptions"
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              isCustomer: true,
                              isBuilder: false,
                              isHOA: false,
                              isLandDeveloper: false,
                            });
                          }}
                          checked={formData?.isCustomer}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="inlineRadio1"
                        >
                          Customer
                        </label>
                      </div> */}
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="inlineRadioOptions"
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              isBuilder: true,
                              // isCustomer: false,
                              isHOA: false,
                              isLandDeveloper: false,
                            });
                          }}
                          checked={formData?.isBuilder}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="inlineRadio2"
                        >
                          Builder
                        </label>
                      </div>
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          name="inlineRadioOptions"
                          type="radio"
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              isLandDeveloper: true,
                              // isCustomer: false,
                              isHOA: false,
                              isBuilder: false,
                            });
                          }}
                          checked={formData?.isLandDeveloper}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="inlineRadio3"
                        >
                          Land Developer
                        </label>
                      </div>
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="inlineRadioOptions"
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              isHOA: true,
                              // isCustomer: false,
                              isLandDeveloper: false,
                              isBuilder: false,
                            });
                          }}
                          checked={formData?.isHOA}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="inlineRadio4"
                        >
                          HOA
                        </label>
                      </div>

                      <div style={{ fontSize: "small", color: "red" }}>
                        {errorMessages.UserType}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-6">
                  <div className="form-group">
                    <label className="searchform-inputlabel">
                      First Name <span>*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id=""
                      placeholder="First Name"
                      value={formData.firstName}
                      onChange={(e) => {
                        e.preventDefault();
                        setFormData({
                          ...formData,
                          firstName: e.target.value,
                        });
                      }}
                    />
                    <div style={{ fontSize: "small", color: "red" }}>
                      {errorMessages.firstName}
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group">
                    <label className="searchform-inputlabel">
                      Last Name <span>*</span>
                    </label>
                    <input
                      value={formData.lastName}
                      type="text"
                      className="form-control"
                      id=""
                      placeholder="Last Name"
                      onChange={(e) => {
                        e.preventDefault();
                        setFormData({
                          ...formData,
                          lastName: e.target.value,
                        });
                      }}
                    />
                    <div style={{ fontSize: "small", color: "red" }}>
                      {errorMessages.lastName}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-6">
                  <div className="form-group">
                    <label className="searchform-inputlabel">
                      Email <span>*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="email"
                      placeholder="Ex:- Johndeo@abc.com"
                      value={formData.emailId}
                      onChange={(e) => {
                        e.preventDefault();
                        setFormData({
                          ...formData,
                          emailId: e.target.value,
                        });
                      }}
                    />
                    <div style={{ fontSize: "small", color: "red" }}>
                      {errorMessages.emailId}
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group">
                    <label className="searchform-inputlabel">
                      Phone <span>*</span>
                    </label>

                    <Input
                      fullWidth
                      value={formData.phone}
                      onChange={(e) => {
                        // e.preventDefault();
                        setFormData({
                          ...formData,
                          phone: e.target.value,
                        });
                      }}
                      disableUnderline
                      inputComponent={TextMaskCustom}
                      style={{ backgroundColor: "white" }}
                    />
                    <div style={{ fontSize: "small", color: "red" }}>
                      {errorMessages.phone}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-6">
                  <div className="form-group">
                    <label className="searchform-inputlabel">
                      Password <span>*</span>
                    </label>
                    <div className="input-group password-group">
                      <input
                        type={showPassword ? "text" : "password"}
                        className="form-control"
                        placeholder="Enter password"
                        value={formData.password}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            password: e.target.value,
                          });
                        }}
                      />
                      <span className="input-group-text">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          {/* {showPassword ? (
                            <i className="fa fa-eye-slash align-middle" />
                          ) : (
                            <i className="fa fa-eye align-middle" />
                          )} */}
                          <label className='cp'>
                              {showPassword ? "Hide":'Show'
                         }
                          </label>
                        </button>
                      </span>
                    </div>
                    <div style={{ fontSize: "small", color: "red" }}>
                      {Array.isArray(errorMessages.password) &&
                        errorMessages.password.map((msg, index) => (
                          <div key={index}>{msg}</div>
                        ))}
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group">
                    <label className="searchform-inputlabel">
                      Confirm Password <span>*</span>
                    </label>
                    <div className="input-group password-group">
                      <input
                        type={showConfirmPassword ? "text" : "password"}
                        className="form-control"
                        placeholder="Confirm password"
                        value={formData.confirmPassword}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            confirmPassword: e.target.value,
                          });
                        }}
                      />
                      <span className="input-group-text">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() =>
                            setShowConfirmPassword(!showConfirmPassword)
                          }
                        >
                          {/* {showConfirmPassword ? (
                            <i className="fa fa-eye-slash align-middle" />
                          ) : (
                            <i className="fa fa-eye align-middle" />
                          )} */}
                           <label className='cp'>
                              {showConfirmPassword ? "Hide":'Show'
                         }
                          </label>
                        </button>
                      </span>
                    </div>
                    <div style={{ fontSize: "small", color: "red" }}>
                      {errorMessages.confirmPassword && (
                        <div>{errorMessages.confirmPassword}</div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-lg-12 text-center">
                  <button
                    style={{ marginTop: "20px", fontSize: "12px" }}
                    className="btn btn-custom startlit_navy min-h-25px"
                    onClick={(e) => {
                      e.preventDefault();
                      clearform();
                    }}
                  >
                    Clear <i className="fas fa-eraser"></i>
                  </button>
                  &ensp;
                  <button
                    style={{ marginTop: "20px", fontSize: "12px" }}
                    className="btn btn-custom electric_cobalt min-h-25px"
                    onClick={(e) => {
                      e.preventDefault();
                      onValidate();
                    }}
                  >
                    Get Account Details{" "}
                    {getSalesForceData?.loader ? (
                      <CircularProgress color="white" size={20} />
                    ) : (
                      <i className="fas fa-search"></i>
                    )}
                  </button>{" "}
                </div>
              </div>
            </>
          )}

          {verifyPhoneAndemail && (
            <div className="row">
              <div className="col-12">
                {associatedAccounts?.length > 0 && (
                  <div className="card-body-content">
                    <div style={{ padding: "30px 0px 10px 30px" }}>
                      <h4 className="text-center">
                        {" "}
                        Active accounts associated with the given email and
                        phone are listed below.
                      </h4>

                      <p className="text-center">
                        To create user please select accounts associated with.
                      </p>
                    </div>

                    <div
                      style={{
                        fontFamily: "Arial, sans-serif",
                        margin: "20px",
                      }}
                    >
                      {!getSalesForceData.loader ? (
                        <>
                          <div
                            style={{
                              maxHeight: "50vh",
                              overflow: "auto",
                            }}
                            className="table-reponsive"
                          >
                            <table className="table table-hover">
                              <thead>
                                <tr>
                                  <th className="text-center text-dark">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      checked={
                                        associatedAccounts.length > 0 &&
                                        selectedAssociatedAccounts.length ===
                                          associatedAccounts.length
                                      }
                                      onChange={handleSelectandunselectAll}
                                      style={{ cursor: "pointer" }}
                                    />
                                  </th>
                                  <th className="text-center text-dark">
                                    Account Id
                                  </th>
                                  <th className="text-center text-dark">
                                    Name
                                  </th>

                                  <th className="text-center text-dark">
                                    Email
                                  </th>
                                  <th className="text-center text-dark">
                                    Phone
                                  </th>

                                  <th className="text-center text-dark">
                                    Account
                                  </th>
                                  <th className="text-center text-dark">
                                    {" "}
                                    Service Type
                                  </th>

                                  <th className="text-center text-dark">
                                    Address
                                  </th>
                                </tr>
                              </thead>

                              <tbody>
                                {associatedAccounts.length > 0 ? (
                                  associatedAccounts.map((account) => (
                                    <tr
                                      key={account.account_id}
                                      onClick={() =>
                                        handleCheckboxChange(account)
                                      }
                                      className={`text-center cp`}
                                      style={{
                                        backgroundColor:
                                          selectedAssociatedAccounts.some(
                                            (item) =>
                                              item.account_id ===
                                              account.account_id
                                          )
                                            ? "#e6f7ff"
                                            : "white",
                                      }}
                                    >
                                      <td
                                        style={{
                                          padding: "12px",
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={selectedAssociatedAccounts.some(
                                            (item) =>
                                              item.account_id ===
                                              account.account_id
                                          )}
                                          onClick={(e) => e.stopPropagation()} // prevent tr click
                                          onChange={() =>
                                            handleCheckboxChange(account)
                                          }
                                          style={{
                                            cursor: "pointer",
                                          }}
                                        />
                                      </td>
                                      <td className="text-center">
                                        {account.account_id}
                                      </td>
                                      <td className="text-center">
                                        {account.name}
                                      </td>
                                      <td className="text-center">
                                        {account.email}
                                      </td>
                                      <td className="text-center">
                                        {account.phone}
                                      </td>
                                      <td className="text-center">
                                        {account.account_number}
                                      </td>
                                      <td className="text-center">
                                        {account.service_type}
                                      </td>

                                      <td className="text-center">
                                        {account.address_line1},{" "}
                                        {account.address_city},{" "}
                                        {account.address_state}{" "}
                                        {account.address_postal_code}
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan="9" className="ndf">
                                      No data found
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>

                          <div className="card-footer d-flex align-items-center justify-content-center bg-white">
                            <div className="d-flex align-items-center gap-10px">
                              <button
                                className="btn btn-custom outline-light"
                                onClick={(e) => {
                                  setVerifyPhoneAndemail(false);
                                }}
                              >
                                Back
                              </button>
                              <button
                                className="btn btn-custom outline-light"
                                onClick={(e) => {
                                  resetSelection();
                                  e.preventDefault();
                                }}
                              >
                                Reset Selection
                              </button>
                              <button
                                className="btn btn-custom electric_cobalt"
                                disabled={
                                  selectedAssociatedAccounts.length === 0
                                }
                                onClick={(e) => {
                                  e.preventDefault();
                                  onClickSave();
                                }}
                              >
                                Create User
                              </button>
                            </div>
                          </div>
                        </>
                      ) : (
                        <div className="card-footer d-flex align-items-center justify-content-center bg-white">
                          <div className="d-flex align-items-center gap-10px">
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "50vh",
                                width: "100vw",
                              }}
                            >
                              <CircularProgress size={30} />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
export default AddCustomerByAdmin;
